export const filterOptions = [
  {
    labels: "Lead Value",
    value: false,
  },
  {
    labels: "Confidence Score",
    value: false,
  },
  {
    labels: "City",
    value: false,
  },
  // {
  //   labels: "Company",
  //   value: false,
  // },
  {
    labels: "Created By",
    value: false,
  },
  {
    labels: "Created Time",
    value: false,
  },
  {
    labels: "Fax",
    value: false,
  },
  {
    labels:"Lead Owner",
    value:false,
  },
   {
    labels: "Lead Status",
    value: false,
  },
  {
    labels: "Industry",
    value: false,
  },
  {
    labels: "Last Activity Time",
    value: false,
  },
  // {
  //   labels: "Converted Contact",
  //   value: false,
  // },
  // {
  //   labels: "Converted Account",
  //   value: false,
  // },
  // {
  //   labels: "Converted Deal",
  //   value: false,
  // },
  {
    labels: "Country",
    value: false,
  },
  {
    labels: "Email",
    value: false,
  },
  // {
  //   labels: "Email Opt Out",
  //   value: false,
  // },
  {
    labels: "First Name",
    value: false,
  },
  {
    labels: "Last Name",
    value: false,
  },
];
export const CREATED_TIME_OPTIONS = [
  { label: "Today", value: "Today" },
  { label: "Yesterday", value: "Yesterday" },
  { label: "This Week", value: "This Week" },
  { label: "This Month", value: "This Month" },
  { label: "Last Week", value: "Last Week" },
  { label: "Last Month", value: "Last Month" },
  { label: "Custom", value: "Custom" },
];